import React from 'react';
import { Card, Typography, Button, Space, Divider } from 'antd';
import { Link } from 'react-router-dom';
import {
  FormOutlined,
  SettingOutlined,
  DatabaseOutlined,
  ExperimentOutlined,
  ProjectOutlined,
  ArrowLeftOutlined
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const DynamicFormNav: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <Title level={2} style={{ margin: 0 }}>动态表单系统</Title>
          <Link to="/">
            <Button icon={<ArrowLeftOutlined />}>
              返回项目列表
            </Button>
          </Link>
        </div>
        <Paragraph>
          这是一个动态表单系统，可以根据配置生成表单，支持多种字段类型和验证规则。
          您可以使用以下链接访问不同的功能页面。
        </Paragraph>
        <Divider />

        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Card title="示例页面" bordered={false}>
            <Paragraph>
              查看动态表单组件的基本使用示例，了解如何配置和使用动态表单。
            </Paragraph>
            <Link to="/dynamic-form-example">
              <Button type="primary" icon={<ExperimentOutlined />}>
                查看示例
              </Button>
            </Link>
          </Card>

          <Card title="设备管理" bordered={false}>
            <Paragraph>
              使用动态表单管理设备信息，包括添加、编辑、删除和查看设备。
            </Paragraph>
            <Link to="/device-management">
              <Button type="primary" icon={<DatabaseOutlined />}>
                设备管理
              </Button>
            </Link>
          </Card>

          <Card title="表单配置管理" bordered={false}>
            <Paragraph>
              管理表单配置，可以创建、编辑、复制和删除表单配置。
            </Paragraph>
            <Link to="/form-config-management">
              <Button type="primary" icon={<SettingOutlined />}>
                表单配置管理
              </Button>
            </Link>
          </Card>
        </Space>
      </Card>
    </div>
  );
};

export default DynamicFormNav; 